import Button from '@/components/Button';
import { ImportDialog } from '../import-dialog';
import { useState } from 'react';
import { InviteDialog } from '../invite-dialog';
import { useInviteStaff } from '../../hooks/useInviteStaff';
import { useManageStaffStore } from '../../store/useManageStaffStore';

export const InviteUsers = ({ refetch }: { refetch: () => void }) => {
  const [isOpenImportDialog, setIsOpenImportDialog] = useState(false);
  const inviteStaff = useManageStaffStore((state) => state?.page?.inviteStaff);
  const {
    isOpenInviteDialog,
    onShowInvitationPreview,
    loadingInvite,
    setIsOpenInviteDialog,
    paginatedData,
    totalPages,
    currentPage,
    handlePageChange,
    onSendInvitationEmail,
    loadingSendInvitation,
  } = useInviteStaff({ refetch });

  return (
    <div className="col-span-12 mt-8">
      <h1 className="font-haffer text-sh-22-28 font-bold">{inviteStaff?.title}</h1>
      <p className="mt-4 font-haffer text-sh-16-24">{inviteStaff?.description}</p>
      <div className="mt-8 flex flex-col gap-4 md:flex-row">
        <Button
          className="w-fit self-start md:w-auto md:self-auto"
          onClick={onShowInvitationPreview}
          loading={loadingInvite}
          disabled={loadingInvite}>
          {inviteStaff?.inviteStaff}
        </Button>
        <Button
          className="w-fit self-start md:w-auto md:self-auto"
          onClick={() => {
            setIsOpenImportDialog(true);
          }}>
          {inviteStaff?.importStaffSpreadsheet}
        </Button>
      </div>
      <InviteDialog
        open={isOpenInviteDialog}
        setOpen={setIsOpenInviteDialog}
        data={paginatedData}
        totalPages={totalPages}
        currentPage={currentPage}
        onChangePage={handlePageChange}
        onConfirmSend={onSendInvitationEmail}
        loadingConfirm={loadingSendInvitation}
      />
      <ImportDialog refetch={refetch} open={isOpenImportDialog} setOpen={setIsOpenImportDialog} />
    </div>
  );
};
